import script from "./GlobusTable.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobusTable.vue?vue&type=script&setup=true&lang=js"

import "./GlobusTable.vue?vue&type=style&index=0&id=ef2a889a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef2a889a"]])

export default __exports__